import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import {
  listReconciliationQuotes,
  listPropertyQuotes,
  listQuoteAttachments,
  uploadQuoteAttachments,
  listStatusesCount,
  downloadQuoteAttachment,
  removeQuoteAttachment,
  listOrganizations,
  updateReconciliationQuote,
} from './thunks/reconciliation-quotes';
import { listReconciliationProperties, listReconciliationPropertiesNext } from './thunks/reconciliation-properties';
import {
  createContribution,
  listContributions,
  listContributorTypes,
  deleteContribution,
  updateContribution,
} from './thunks/contributions';
import { reconciliationQuotesReducers } from './extra-reducers/reconciliation-quotes';
import { reconciliationPropertiesReducers } from './extra-reducers/reconciliation-properties';
import { contributionsReducers } from './extra-reducers/contributions';
import {
  selectQuoteItemReducer,
  selectQuoteProductReducer,
  selectQuoteReducer,
  setQuoteFilterCreatedByMeReducer,
  setQuoteFilterSelectedOrganizationsReducer,
  setQuoteFilterSelectedStatusesReducer,
  setQuoteSortReducer,
  setReconciliationReducer,
  setContributionReducer,
} from './reducers';

export {
  listReconciliationQuotes,
  listPropertyQuotes,
  listQuoteAttachments,
  uploadQuoteAttachments,
  listStatusesCount,
  downloadQuoteAttachment,
  removeQuoteAttachment,
  listOrganizations,
  updateReconciliationQuote,

  //reconciliation properties
  listReconciliationProperties,
  listReconciliationPropertiesNext,

  //contributions
  listContributions,
  createContribution,
  deleteContribution,
  updateContribution,
  listContributorTypes,
};

export const reconciliationSlice = createSlice({
  name: 'reconciliation',
  initialState,
  reducers: {
    selectQuoteProduct: selectQuoteProductReducer,
    selectQuote: selectQuoteReducer,
    selectQuoteItem: selectQuoteItemReducer,
    setQuoteFilterSelectedStatuses: setQuoteFilterSelectedStatusesReducer,
    setQuoteFilterSelectedOrganizations: setQuoteFilterSelectedOrganizationsReducer,
    setQuoteFilterCreatedByMe: setQuoteFilterCreatedByMeReducer,
    setQuoteSort: setQuoteSortReducer,
    setReconciliation: setReconciliationReducer,
    setContribution: setContributionReducer,
  },
  extraReducers(builder) {
    reconciliationQuotesReducers(builder);
    reconciliationPropertiesReducers(builder);
    contributionsReducers(builder);
  },
});

export const {
  selectQuoteProduct,
  selectQuote,
  selectQuoteItem,
  setQuoteFilterSelectedStatuses,
  setQuoteFilterSelectedOrganizations,
  setQuoteFilterCreatedByMe,
  setQuoteSort,
  setReconciliation,
  setContribution,
} = reconciliationSlice.actions;

export default reconciliationSlice.reducer;
